/* eslint-disable */
import EventBus, { ACTIONS } from '../eventBus/index'

export const showSnackbar = (message, attr = {}) => {
  EventBus.$emit(ACTIONS.SNACKBAR, { message: message, options: attr })
}
